export var methodType = {
  APPLE_PAY: 'applePay',
  GOOGLE_PAY: 'googlePay',
  NEW_CARD: 'newCard'
};